import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  margin-top: -10px;
`;

const DetailsButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 20px;
  background-color: #e4790b;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f36e20; /* Darker green on hover */
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    4,
    minmax(250px, 1fr)
  ); /* Limit to 4 cards per row */
  gap: 20px;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;

const ProductCard = styled.div`
  border: 1px solid #ccc;
  color: #f36e20;
  padding: 10px;
  border-radius: 5px;
  transition: transform 0.3s ease-in-out; /* Apply transition here */
  text-align: center; /* Center text horizontally */

  &:hover {
    transform: scale(1.05); /* Example transformation */
  }
`;

const Heading = styled.h2`
  margin: 10px 0; /* Add margin top and bottom */
  display: flex;
  flex-direction: column;
  align-items: left; /* Center horizontally */
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    transition: transform 0.3s ease-in-out;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 40px;
    font-size: clamp(
      6px,
      2vw,
      24px
    ); /* Font size adjusts between 12px and 16px based on viewport width */
    text-align: center; /* Center text for smaller screens */
  }
`;

const Text = styled.span`
  color: #f36e20;
  font-size: clamp(
    26px,
    6vw,
    12px
  ); /* Font size adjusts between 20px and 32px based on viewport width */
  margin-bottom: -30px; /* Adjust the negative margin to bring the lines closer */
  margin-top: 20px;
`;

const Services = () => {
  const data: Record<string, { name: string; image: any }[]> = {
    services: [
      {
        name: "Plumbing",
        image: require("../assets/images/services/plumbing.webp"),
      },
      {
        name: "Electrical",
        image: require("../assets/images/services/electrical.webp"),
      },
      {
        name: "Installation",
        image: require("../assets/images/services/installation.webp"),
      },
      {
        name: "Maintenance",
        image: require("../assets/images/services/maintenance.webp"),
      },
      {
        name: "Repairs",
        image: require("../assets/images/services/repairs.webp"),
      },
      {
        name: "Drywall",
        image: require("../assets/images/services/drywall.webp"),
      },
      {
        name: "Carpentry",
        image: require("../assets/images/services/carpentry.webp"),
      },
      {
        name: "Painting",
        image: require("../assets/images/services/painting.webp"),
      },
    ],
  };

  return (
    <Container>
      <Heading>
        <Text>Services we provide:</Text> <br />{" "}
      </Heading>
      <ProductGrid>
        {Object.values(data)
          .flat()
          .map((item: any, index: number) => (
            <ProductCard key={index}>
              <img src={item.image} alt={item.name} style={{ width: "100%" }} />
              <h4>{item.name}</h4>
              <Link to="/contact">
                <DetailsButton>Contact Us</DetailsButton>
              </Link>
            </ProductCard>
          ))}
      </ProductGrid>
    </Container>
  );
};

export default Services;
